import { render } from "./LegalWarning.vue?vue&type=template&id=236c4654&ts=true"
import script from "./LegalWarning.vue?vue&type=script&lang=ts"
export * from "./LegalWarning.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__